export default __webpack_public_path__ + "static/media/default-cover-1.f7b1e5af.png";